<msp-config-card-wrapper
  [width]="'575px'"
  [height]="'422px'"
  [icon]="icon"
  [cardState]="cardState"
  [title]="title"
  [isSaveDisabled]="isSaveDisabled()"
  [canEdit]="canEdit"
  (onCancel)="onCancel()"
  (onEdit)="onEdit()"
  (onSave)="onSave()"
>
  @if (cardState === 'view') {
    <div class="module-approval-body h-100">
      @if (moduleApprovers.length > 0) {
        <p class="module-approval__description mb-2">
          <span class="text-udt-blue font-weight-regular">{{ moduleApprovalType?.name }}</span> from the below approvers
          can approve.
        </p>
        <ol class="module-approval__domains-list">
          @for (approver of moduleApprovers; track approver.id) {
            <li class="module-approval__domain">
              <span>{{ approver.fullName }}</span>
            </li>
          }
        </ol>
      } @else {
        <div class="d-flex flex-column justify-content-center align-items-center h-100">
          <mat-icon class="empty-icon material-symbols-outlined">group_add</mat-icon>
          <p class="mb-0 font-weight-regular">No Approvers Selected</p>
          <p class="mb-0 text-grey font-size-body2" style="font-style: italic">
            Please use the edit button to select approvers
          </p>
        </div>
      }
    </div>
  }
  @if (cardState === 'edit' || cardState === 'saving') {
    <div>
      <p class="mb-2">Choose approval sequence, then list user emails in sequential order.</p>
      <radio-group
        [options]="radioGroupOptions"
        [reactiveForm]="approvalForm"
        [controlName]="approvalTypeInputName"
      ></radio-group>
      @if (cardState === 'edit' || cardState === 'saving') {
        <div class="chips-autocomplete">
          <chips-autocomplete
            [isDisabled]="cardState === 'saving'"
            [maxChipsListHeight]="'70px'"
            [maxAddedItems]="5"
            [placeholder]="'Search Users'"
            [autocompleteOptions]="autocompleteUsersOptions"
            [initialOptions]="getSelectedUsers()"
            (optionSelected)="optionSelected($event)"
          ></chips-autocomplete>
          <custom-checkbox
            [label]="checkboxTitle"
            [reactiveForm]="approvalForm"
            [controlName]="allowOverrideInputName"
          ></custom-checkbox>
        </div>
      }
    </div>
  }
</msp-config-card-wrapper>
